export default __webpack_public_path__ + "static/media/dough.be585bb4.jpg";